var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('h5',[_vm._v("Failure Page")])]),_c('p',{staticClass:"title"},[_vm._v("Transaction Failed")])])
}]

export { render, staticRenderFns }